"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var merchantCategoryApi = _interopRequireWildcard(require("@/api/merchantCategoryApi"));
var _CategoryDialog = _interopRequireDefault(require("./components/CategoryDialog.vue"));
var _categoryTree = require("@/utils/categoryTree");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'StoreCategory',
  components: {
    CategoryDialog: _CategoryDialog.default
  },
  data: function data() {
    return {
      // 搜索表单数据
      pageFrom: {
        page: 1,
        limit: 20,
        name: '',
        status: null // 改为null，表示查询全部
      },
      // 表格数据
      tableList: [],
      // tableData: {
      //   list: [],
      //   total: 0
      // },

      loading: false,
      // 弹窗相关
      dialogVisible: false,
      dialogTitle: '添加分类',
      isEdit: false,
      // 是否禁用上级分类选择框
      isParentSelectDisabled: false,
      // 分类表单
      categoryForm: {
        id: null,
        pid: '0',
        name: '',
        extra: '',
        // 分类图标
        sort: 0,
        status: true // 改为boolean类型
      },
      // 上级分类选项（使用tableData.list的数据）
      parentCategoryOptions: [],
      // 是否为添加子分类模式
      isAddSubCategory: false,
      // 展开的行key
      expandRowKeys: []
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    // 获取列表数据
    getList: function () {
      var _getList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var response, tree, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.loading = true;
              _context.p = 1;
              _context.n = 2;
              return merchantCategoryApi.getMerchantCategoryTree({
                status: this.pageFrom.status,
                name: this.pageFrom.name,
                type: 1
              });
            case 2:
              response = _context.v;
              console.log('response:', response);
              if (response) {
                tree = (0, _categoryTree.annotateCategoryLevels)(response);
                this.tableList = tree;
                this.parentCategoryOptions = (0, _categoryTree.markMaxLevelParentDisabled)(JSON.parse(JSON.stringify(tree)));
              }
              console.log(this.$refs.treeList.store.states.treeData, document.querySelectorAll('.el-table__row--level-1'));
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.error('获取分类列表失败:', _t);
              this.$message.error('获取数据失败：' + (_t.message || '未知错误'));
              // 使用模拟数据作为备选
              // this.getMockData()
            case 4:
              _context.p = 4;
              this.loading = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }(),
    // 搜索
    search: function search() {
      this.pageFrom.page = 1;
      this.getList();
    },
    // 重置搜索
    resetSearch: function resetSearch() {
      this.pageFrom = {
        page: 1,
        limit: 20,
        name: '',
        status: null // 重置为null
      };
      this.getList();
    },
    // 分页大小改变
    handleSizeChange: function handleSizeChange(val) {
      this.pageFrom.limit = val;
      this.getList();
    },
    // 页码改变
    pageChange: function pageChange(val) {
      this.pageFrom.page = val;
      this.getList();
    },
    // 添加分类
    addCategory: function addCategory() {
      this.dialogTitle = '添加分类';
      this.isParentSelectDisabled = false;
      this.isEdit = false;
      this.isAddSubCategory = false;
      this.resetForm();
      this.dialogVisible = true;
    },
    canAddSubCategory: function canAddSubCategory(row) {
      return (0, _categoryTree.canAddSubCategory)(row);
    },
    // 添加子分类
    addSubCategory: function addSubCategory(row) {
      if (!(0, _categoryTree.canAddSubCategory)(row)) {
        this.$message.warning('第三层分类不能再添加子分类');
        return;
      }
      this.dialogTitle = '添加子分类';
      this.isEdit = false;
      this.isAddSubCategory = true;
      this.isParentSelectDisabled = true;
      this.resetForm();
      this.categoryForm.pid = row.id;
      this.dialogVisible = true;
    },
    // 编辑分类
    editCategory: function editCategory(row) {
      var _this = this;
      this.dialogTitle = '编辑分类';
      this.isEdit = true;
      this.isAddSubCategory = false;
      this.isParentSelectDisabled = false;

      // 直接使用表格数据进行回显
      this.categoryForm = {
        id: row.id,
        pid: row.pid || 0,
        name: row.name,
        extra: row.extra || '',
        sort: row.sort || 0,
        status: row.status
      };
      // 清除之前的验证错误
      this.$nextTick(function () {
        if (_this.$refs.categoryDialog) {
          _this.$refs.categoryDialog.clearValidate();
        }
      });
      this.dialogVisible = true;
    },
    // 删除分类
    deleteCategory: function deleteCategory(row) {
      var _this2 = this;
      this.$confirm("\u786E\u5B9A\u8981\u5220\u9664\u5206\u7C7B\"".concat(row.name, "\"\u5417\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return merchantCategoryApi.deleteMerchantCategory(row.id);
            case 1:
              _this2.$message.success('删除成功');
              _this2.getList();
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              _this2.$message.error('删除失败：' + (_t2.message || '未知错误'));
            case 3:
              return _context2.a(2);
          }
        }, _callee2, null, [[0, 2]]);
      }))).catch(function () {
        _this2.$message.info('已取消删除');
      });
    },
    // 状态切换
    changeStatus: function () {
      var _changeStatus = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(row) {
        var _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              _context3.n = 1;
              return merchantCategoryApi.updateMerchantCategoryStatus(row.id, row.status);
            case 1:
              this.$message.success('状态更新成功');
              this.getList();
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              this.$message.error('状态更新失败：' + (_t3.message || '未知错误'));
              // 失败时恢复状态
              row.status = !row.status;
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function changeStatus(_x) {
        return _changeStatus.apply(this, arguments);
      }
      return changeStatus;
    }(),
    // 提交表单（来自子组件的事件）
    submitForm: function () {
      var _submitForm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(formData) {
        var _t4;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              if ((0, _categoryTree.validateCategoryParentLevel)(formData.pid, this.tableList)) {
                _context4.n = 1;
                break;
              }
              this.$message.warning('分类最多支持三层，无法再添加子分类');
              return _context4.a(2);
            case 1:
              _context4.p = 1;
              if (!this.isEdit) {
                _context4.n = 3;
                break;
              }
              _context4.n = 2;
              return merchantCategoryApi.updateMerchantCategory(_objectSpread(_objectSpread({}, formData), {}, {
                type: 1
              }));
            case 2:
              this.$message.success('编辑成功');
              _context4.n = 5;
              break;
            case 3:
              _context4.n = 4;
              return merchantCategoryApi.saveMerchantCategory(_objectSpread(_objectSpread({}, formData), {}, {
                type: 1
              }));
            case 4:
              this.$message.success('添加成功');
            case 5:
              this.dialogVisible = false;
              this.getList();
              _context4.n = 7;
              break;
            case 6:
              _context4.p = 6;
              _t4 = _context4.v;
              this.$message.error((this.isEdit ? '编辑' : '添加') + '失败：' + (_t4.message || '未知错误'));
            case 7:
              return _context4.a(2);
          }
        }, _callee4, this, [[1, 6]]);
      }));
      function submitForm(_x2) {
        return _submitForm.apply(this, arguments);
      }
      return submitForm;
    }(),
    // 重置表单
    resetForm: function resetForm() {
      this.categoryForm = {
        id: null,
        pid: 0,
        name: '',
        extra: '',
        sort: 0,
        status: true // 改为boolean类型
      };
      this.dialogVisible = false;
      // 清除子组件的验证
      if (this.$refs.categoryDialog) {
        this.$refs.categoryDialog.clearValidate();
      }
    },
    // 处理图标上传（来自子组件的事件）
    handleIconChange: function handleIconChange(iconUrl) {
      this.categoryForm.extra = iconUrl;
    },
    // 处理分类选择变化（来自子组件的事件）
    handleCategoryChange: function handleCategoryChange(categoryId) {
      console.log('选择的分类ID:', categoryId);
      // 可以在这里添加选择后的额外逻辑，比如验证、联动等
      this.categoryForm.pid = categoryId;
    }
  }
};